export const GET_DATAISSUESMAINTENANCEMODE_ABORTED =
  'GET_DATAISSUESMAINTENANCEMODE_ABORTED';
export const GET_DATAISSUESMAINTENANCEMODE_REQUESTED =
  'GET_DATAISSUESMAINTENANCEMODE_REQUESTED';
export const GET_DATAISSUESMAINTENANCEMODE_COMPLETED =
  'GET_DATAISSUESMAINTENANCEMODE_COMPLETED';
export const GET_DATAISSUESMAINTENANCEMODE_FAILED =
  'GET_DATAISSUESMAINTENANCEMODE_FAILED';
